
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import FinancingNeedsReport from "@/components/processing_steps/commons/fields/FinancingNeedsReport.vue"
import { IFinancingNeedItemReport, IFinancingNeedItemReportForm } from "@/types/processingSteps"
import { IProject } from "@/types/projects"
import FormTitle from "@/components/processing_steps/FormTitle.vue"

@Component({
  components: {
    FormTitle,
    FinancingNeedsReport,
    FormContainer
  }
})
export default class FinanceForm extends Vue {
  @Prop() financingNeedReportItems!: IFinancingNeedItemReport[]
  @Prop() resultReportSlug!: string
  @Prop() project: IProject
  @Prop() isDisabled!: boolean

  localFinancingNeedReportItem: IFinancingNeedItemReportForm = {
    title: '',
    description: '',
    expense_type: 1,
    expense_amount: 0,
    report_files: [],
    report_photos: [],
    file_album_slug: '',
    result_report_slug: ''
  }

  createMode = false

  createDetailedFinancingNeeds(): void {
    this.$emit("files-uploaded")
  }

  handleCreateClick(): void {
    this.onCreate()
    const btn = this.$refs.addButton as HTMLElement
    btn?.blur()
  }

  onCreate(): void {
    this.createMode = true
    this.localFinancingNeedReportItem = {
      title: '',
      description: '',
      expense_type: 1,
      expense_amount: 0,
      report_files: [],
      report_photos: [],
      file_album_slug: '',
      result_report_slug: this.resultReportSlug
    }
  }

  onItemCreated(): void {
    this.$emit("files-uploaded")
    this.createMode = false
  }
}
